import { Flex, Text } from "@chakra-ui/react";
import { H1 } from "../../../components/text/headings";
import FootPrint from "./components/FootPrint";
import { Page } from "../../../components/Page";
import SupplierCards from "./supplier-components/SupplierCards";
import SupplierTrends from "./supplier-components/SupplierTrends";
import SupplierEngagement from "./supplier-engagement/SupplierEngagement";

const SupplierInsights = () => {
  return (
    <Page>
      <Flex direction="column" gap={2} mx="10%">
        <H1 fontSize="heading.3xl">Supply Chain</H1>
        <Text maxW="75%" color="gray.500" fontSize="body.m">
          Monitor  and track key indicators and trends on sustainability performance across your organisation and supply chain all in one place
        </Text>

        <SupplierCards />
      </Flex>

    </Page>
  );
};

export default SupplierInsights;
